import React from "react";
import Firebase from "./firebaseAuth";
import { Redirect } from "react-router-dom";
import auth from "../../services/authService";

const Login = () => {
  if (auth.getCurrentUser()) return <Redirect to="/"></Redirect>;
  return (
    <div className="container h-100 justify-content-center align-items-center ">
      <div className="row py-5">
        <div className="col-md-12 justify-content-center d-flex py-5 rounded">
          <div className="card rgba-white-slight hoverable col-md-5">
            <div className="card-body">
              <h2 className="text-center mb-3 mt-4 font-weight-bold">
                <strong>SIGN IN WITH</strong>
              </h2>
              <hr />
              <div>
                <Firebase></Firebase>
              </div>
              <hr />
              <p className="text-center">
                By sign in with you agree to our{" "}
                <a href="">Terms & conditions</a>.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
